import { render } from "./chat_list.vue?vue&type=template&id=66fabc09"
import script from "./chat_list.js?vue&type=script&lang=js"
export * from "./chat_list.js?vue&type=script&lang=js"

import "./chat_list.vue?vue&type=style&index=0&id=66fabc09&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__